import { Modal } from "@mantine/core";
import { useContainerRef } from "../../../../hooks/useContainerRef";
import { ModalFooter } from "../../../../mantine/components/ModalFooter/ModalFooter";
import type { ProjectMinimal } from "../../../../utils/backend-types";
import { CreateManagerProjectForm } from "./CreateManagerProjectForm";

interface CreateProjectModalProps {
  isOpen: boolean;
  toggle: () => void;
  onClickSave: (project: ProjectMinimal) => void;
}

function CreateProjectModal({
  isOpen,
  toggle,
  onClickSave
}: CreateProjectModalProps) {
  const { containerNode, containerRef } = useContainerRef();

  return (
    <Modal
      className="CreateProjectModal"
      opened={isOpen}
      title="Neues Projekt"
      onClose={toggle}
    >
      <CreateManagerProjectForm
        buttonContainer={containerNode}
        onCancel={toggle}
        onSubmit={onClickSave}
      />
      <ModalFooter ref={containerRef} />
    </Modal>
  );
}

export { CreateProjectModal };
